import * as ibantools from 'ibantools';

/**
 * Source for validation data: https://docs.google.com/spreadsheets/d/1HJD_n6lIC12PAmceKk0o-BlZkKQUUUJXd_HBc8RF1ao/edit#gid=20913079
 */

export const isValidIban = (value: string): boolean => {
  const iban = ibantools.electronicFormatIBAN(value);
  return ibantools.isValidIBAN(iban as string);
};

export const isValidBban = (value: string, countryCode: string): boolean => {
  const trimmedValue = value.replace(/\s/g, '');

  switch (countryCode) {
    case 'ISR': // https://www.ecbs.org/iban/israel-bank-account-number.html
      return /^\d{1,3}-\d{1,3}-\d{1,13}$/.test(trimmedValue) || /^\d{19}$/.test(trimmedValue);
    case 'JPN': // TODO: This needs to be confirmed!
      return /^(FU|TO|SO|TI)-\d{4,7}$/.test(trimmedValue);
    case 'SRB': // https://www.ecbs.org/iban/serbia-bank-account-number.html
      return /^\d{3}-\d{6,13}-\d{2}$/.test(trimmedValue) || /^\d{18}$/.test(trimmedValue);
    case 'SVN': // https://www.ecbs.org/iban/slovenia-bank-account-number.html
      return /^\d{1,5}-\d{1,10}$/.test(trimmedValue) || /^\d{15}$/.test(trimmedValue);
    case 'DNK':
      return /^\d{4}-?(\d{7,10})$/.test(trimmedValue);
    default:
      return false;
  }
};

// see: https://github.com/creditornot/legitimizer/blob/master/src/main/kotlin/com/wolt/legitimizer/kyb/submission/Validations.kt
// more info: Bank Identifier aka. BIC or Swift code https://en.wikipedia.org/wiki/ISO_9362
//
//
// The SWIFT code is 8 or 11 characters, made up of:
// 4 letters: institution code or bank code.
// 2 letters: ISO 3166-1 alpha-2 country code
// (exceptionally, SWIFT has assigned the code XK to Republic of Kosovo, which does not have an ISO 3166-1 country code)
// 2 letters or digits: location code
// - if the second character is "0", then it is typically a test BIC as opposed to a BIC used on the live network.
// - if the second character is "1", then it denotes a passive participant in the SWIFT network
// - if the second character is "2", then it typically indicates a reverse billing BIC, where the recipient pays for the message as opposed to the more usual mode whereby the sender pays for the message.
// 3 letters or digits: branch code, optional ('XXX' for primary office)
const bicSwiftRegex = /^[A-Za-z]{6}[A-Za-z2-9][A-Na-nP-Zp-z0-9]([A-Za-z0-9]{3})?$/;

export const isValidBicOrRoutingCode = (value: string, countryCode: string): boolean => {
  const trimmedValue = value.replace(/\s/g, '');

  switch (countryCode) {
    case 'JPN': // TODO: This needs to be confirmed!
      return /^\d{4}-\d{3}$/.test(trimmedValue) || /^\d{7}$/.test(trimmedValue);
    default:
      return bicSwiftRegex.test(trimmedValue);
  }
};
